import { Box, Button, Typography } from '@mui/material';

const SectionHeader = ({ action, eyebrow, subtitle, title, onAction }) => (
  <Box
    data-testid="section-header"
    sx={{
      px: 0.5,
      mb: 2,
    }}
  >
    <Box
      data-testid="section-header-row"
      sx={{
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        gap: 2,
        minWidth: 0,
      }}
    >
      <Typography variant="h3">{title}</Typography>

      {(action || eyebrow) && (
        <Button
          size="small"
          color="secondary"
          onClick={onAction}
          sx={{
            minWidth: 0,
            px: 0,
            color: 'secondary.dark',
            flex: '0 0 auto',
            fontSize: '0.7rem',
            fontWeight: 800,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
          }}
        >
          {action || eyebrow}
        </Button>
      )}
    </Box>

    {subtitle && (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
        {subtitle}
      </Typography>
    )}
  </Box>
);

export default SectionHeader;
